import { PPRouteNames } from './pp-routing-constants';

export const THE_OPEN_CHAMPIONSHIP = 'theopen';
export const AIG_WOMENS_OPEN_CHAMPIONSHIP = 'aigwo';

export const PPQualificationClassName = 'qualification';

export const enum PPClassNames {
  TheOpen = THE_OPEN_CHAMPIONSHIP,
  AIGWO = AIG_WOMENS_OPEN_CHAMPIONSHIP,
  Auth = PPRouteNames.Auth,
  Qualification = PPQualificationClassName,
}
